module.exports = __webpack_public_path__ + "static/media/LOGO_LTI.8ea005b3.png";